export default __webpack_public_path__ + "static/equilibre_iphone_podcast-42eab6061f07c67293f8413d0188e21c.png";